export default __webpack_public_path__ + "static/media/15.496406a6.webp";